<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            v-if="formParam.id != '' && formParam.id != null"
          >
            Edit Grup
          </h5>
          <h5 class="modal-title" v-else>Tambah Grup</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>
                      Judul:
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formParam.name"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Deskripsi:</label>
                        <div class="message-bar">
                          <div class="message-inner">
                            <div class="message-area">
                              <div class="input-group m-b-30">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="formParam.description"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending == false">
                    <!-- {{isSending}} -->
                    <!-- <button @click="saveForm(0)" class="btn btn-md btn-success" type="button">
                      <i class="fa fa-check"></i> Save
                    </button>
                    <button
                      @click.prevent="saveForm(1)"
                      class="btn btn-md btn-info"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Save &amp; Exit
                    </button> -->
                    <div class="dropdown">
                      <button
                        class="btn btn-md btn-info dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="fa fa-check"></i> Save
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="saveForm(1)"
                            >Save &amp; Close</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="saveForm(2)"
                            >Save &amp; Import Contact</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click.prevent="saveForm(3)"
                            >Save &amp; Sync Contact</a
                          >
                        </li>
                      </ul>
                    </div>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC,
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
  },
  props: {
    searchData: {
      type: Function,
    },
  },
  data() {
    return {
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px",
      },
      isSending: false,

      formParam: {
        id: "",
        name: "",
        description: "",
      },
      isLoading: false,
    };
  },
  watch: {
    isShowForm: {
      handler: function (val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function () {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamGroupSt.id != "" &&
              that.formParamGroupSt.id != null
            ) {
              that.formParam = that.formParamGroupSt;
            } else {
              that.formParam = {
                id: "",
                name: "",
                description: "",
              };
            }
          }, 100);
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["agentSession"]),
    formParamGroupSt() {
      return this.$store.state.contact.formParamGroupSt;
    },
    isShowForm() {
      return this.$store.state.contact.isShowForm;
    },
  },
  methods: {
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },

    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then(async (r) => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          let action = "createGroup";
          if (this.formParam.id != "") {
            action = "updateGroup";
          }
          await this.$store
            .dispatch("contact/" + action, this.formParam)
            .then((response) => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  id: "",
                  name: "",
                  description: "",
                };
              }
              console.log(isExit);
              // if (isExit == 1) {

              // }
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000,
              }).then((r) => {});
              this.searchData();
              var elem = this.$refs.dismisModal;
              elem.click();
              this.formParam = {
                id: "",
                name: "",
                description: "",
              };
              console.log(response)
              if (isExit == 2) {
                let route =
                  "/contacts/import-contacts?group_id=" + response.id;
                var elem = this.$refs.dismisModal;
                elem.click();
                this.$router.push(route);
              }
              if (isExit == 3) {
                let route =
                  "/contacts/sync-contacts?group_id=" + response.id;
                var elem = this.$refs.dismisModal;
                elem.click();
                this.$router.push(route);
              }

              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add",
};
</script>



// WEBPACK FOOTER //
// src/views/crm/group/form.vue